import shajs from 'sha.js';
import {LOGIN_MUTATION} from '@graphql';

const initialState = () => ({
  email: '',
  password: '',
  loading: false
});

const state = initialState();

const getters = {
  state: () => state
};

const actions = {
  changeFields({commit}, {event, name}) {
    commit('UPDATE_KEY', {value: event.target.value, name});
  },
  async submitLogin({commit}, {apollo}) {
    commit('UPDATE_KEY', {name: 'loading', value: true});
    try {
      const response = await apollo.mutate({
        mutation: LOGIN_MUTATION,
        // Parameters
        variables: {
          email: state.email,
          password: shajs('sha256').update(state.password).digest('hex')
        }
      });

      commit('UPDATE_KEY', {name: 'loading', value: false});
      if (response.data) {
        const {token, user, customer} = response.data.login;
        commit('AUTH_SUCCESS', {token, user, customer}, {root: true});
      }
    } catch (error) {
      commit('UPDATE_KEY', {name: 'loading', value: false});
      throw error;
    }
  }
};

const mutations = {
  UPDATE_KEY(state, {name, value}) {
    state[name] = value;
  },
  RESET() {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
